import { useQuery } from '@tanstack/react-query'

import { useServer } from 'app/server/context'
import { MINS_TO_MS } from 'shared/constants'
import { RetryQuery } from 'shared/queries/utils'
import { useUser } from 'users/queries/detail'
import { convertSummary } from './shared/convert'
import keys from './shared/keys'
import * as Response from './shared/response'
import { NotificationsSummaryData } from './shared/types'

export function useNotificationsSummary<T = NotificationsSummaryData>(
  select?: (data: NotificationsSummaryData) => T,
  retryQuery?: RetryQuery
) {
  const { server } = useServer()
  const { data: user } = useUser()

  return useQuery<NotificationsSummaryData, unknown, T>({
    queryKey: keys.summary(),
    queryFn: fetchNotificationsSummary,
    enabled: !!user?.permissions?.canSeeNotifications,
    refetchInterval: 5 * MINS_TO_MS,
    retry: retryQuery ?? false,
    select,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchIntervalInBackground: true,
  })

  async function fetchNotificationsSummary() {
    const url =
      user?.role === 'helper'
        ? '/v2/helpers/me/notifications/summary'
        : '/v2/managers/me/notifications/summary'

    return convertSummary(await server.get<Response.Summary>(url))
  }
}
